// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  nominatedBusinessId: __t.string(),
  intendedInvestmentDollars: __t.u32(),
  reason: __t.option(__t.string()),
  email: __t.option(__t.string()),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  consentToDisplay: __t.option(__t.bool()),
};
